import { atom } from 'jotai';
import { useAtomValue, useSetAtom } from 'jotai/index';
import { selectAtom } from 'jotai/utils';

const payloadAtom = atom<boolean>(false);

const isOpenAtom = selectAtom(payloadAtom, p => !!p);
const closeModalAtom = atom(null, (_, set) => set(payloadAtom, false));
const openModalAtom = atom(null, (_, set) => set(payloadAtom, true));
const toggleModalAtom = atom(null, (_, set) => set(payloadAtom, p => !p));
export const useIsOpenFilterBar = () => useAtomValue(isOpenAtom);
export const useCloseFilterBar = () => useSetAtom(closeModalAtom);
export const useOpenFilterBar = () => useSetAtom(openModalAtom);
export const useToggleFilterBar = () => useSetAtom(toggleModalAtom);
